import { Phone, Mail, MapPin } from "lucide-react";
import { PHONE_DISPLAY, PHONE_LINK, EMAIL, LOGO_URL, AREA, BRAND_NAME } from "@/lib/constants";

const cities = ["Marseille", "Aix-en-Provence", "Vitrolles", "Marignane", "Martigues", "Aubagne", "Salon-de-Provence", "Istres"];

export default function Footer() {
  return (
    <footer className="bg-slate-950 text-slate-300 pt-16 pb-8" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <img src={LOGO_URL} alt={BRAND_NAME} className="h-14 w-auto bg-white rounded-xl p-3" />
            <p className="mt-5 text-slate-400 leading-relaxed max-w-md">
              {BRAND_NAME} — Enlèvement, manutention et destruction confidentielle d'archives papier
              dans tous les {AREA}. Service clé en main pour professionnels.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-sm font-bold uppercase tracking-widest text-white">Contact</div>
            <ul className="mt-5 space-y-3 text-sm">
              <li>
                <a href={`tel:${PHONE_LINK}`} className="flex items-center gap-2 hover:text-white" data-testid="footer-phone">
                  <Phone className="h-4 w-4 text-blue-400" />
                  {PHONE_DISPLAY}
                </a>
              </li>
              <li>
                <a href={`mailto:${EMAIL}`} className="flex items-center gap-2 hover:text-white break-all" data-testid="footer-email">
                  <Mail className="h-4 w-4 text-blue-400" />
                  {EMAIL}
                </a>
              </li>
              <li className="flex items-center gap-2">
                <MapPin className="h-4 w-4 text-blue-400" />
                {AREA} (13)
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-sm font-bold uppercase tracking-widest text-white">Zones d'intervention</div>
            <p className="mt-5 text-sm text-slate-400 leading-relaxed">
              {cities.join(" · ")} et toutes les communes du 13.
            </p>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row gap-3 sm:items-center justify-between text-xs text-slate-500">
          <div>© {new Date().getFullYear()} ArchivExpress — Tous droits réservés.</div>
          <div className="flex gap-5">
            <a href="#top" className="hover:text-white" data-testid="footer-mentions">Mentions légales</a>
            <a href="#top" className="hover:text-white" data-testid="footer-rgpd">RGPD</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
